import { render, staticRenderFns } from "./historyRecord.vue?vue&type=template&id=799e2ce9&scoped=true&"
import script from "./historyRecord.vue?vue&type=script&lang=js&"
export * from "./historyRecord.vue?vue&type=script&lang=js&"
import style0 from "./historyRecord.vue?vue&type=style&index=0&id=799e2ce9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799e2ce9",
  null
  
)

export default component.exports